import { render, staticRenderFns } from "./RequestDialog.vue?vue&type=template&id=4172e054&scoped=true&"
import script from "./RequestDialog.vue?vue&type=script&lang=js&"
export * from "./RequestDialog.vue?vue&type=script&lang=js&"
import style0 from "./RequestDialog.vue?vue&type=style&index=0&id=4172e054&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4172e054",
  null
  
)

export default component.exports